import 'es5-shim';
import 'd3';
import 'handlebars/runtime';
import 'markets-components-core';
import 'markets-components-chartdatamanager';
import 'markets-components-svgplot';
import 'markets-components-minichart';
import 'markets-components-minichart/build/markets-components-minichart.min.css';
